import * as yup from "yup";
import { t } from "i18next";
import type { AccessPinCodeRequest } from "@/services/api/entities/pinCode";

export const getPinCodeSchema = () => {
  return yup.object<AccessPinCodeRequest>().shape({
    pin: yup.string().required(t("validation.required")),
  });
};
